(function () {
  angular
    .module("akitabox.core.services.timeZone", [
      "akitabox.constants",
      "akitabox.core.services.building",
      "akitabox.core.services.organization",
    ])
    .factory("TimeZoneService", TimeZoneService);

  /* @ngInject */
  function TimeZoneService(
    // AkitaBox
    BuildingService,
    OrganizationService
  ) {
    var service = {
      // Retrieve
      getCurrentTimeZone: getCurrentTimeZone,
      getCurrentUTCOffset: getCurrentUTCOffset,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /******************* *
     *   Retrieve
     ******************* */

    function getCurrentTimeZone() {
      var currentBuilding = BuildingService.getCurrent();
      if (currentBuilding) {
        return currentBuilding.time_zone;
      }
      var currentOrganization = OrganizationService.getCurrent();
      if (currentOrganization) {
        return currentOrganization.time_zone;
      }
      // default case
      return "UTC";
    }

    function getCurrentUTCOffset() {
      var currentBuilding = BuildingService.getCurrent();
      if (currentBuilding) {
        return currentBuilding.time_zone_offset;
      }
      var currentOrganization = OrganizationService.getCurrent();
      if (currentOrganization) {
        return currentOrganization.time_zone_offset;
      }
      // default case
      return "";
    }
  }
  // ==============
})();
